<template lang="pug">
  .component-vehicle-damage
    .damage-container
      img.car-outline(v-on:click="addPin", :src="vehicleDamagePicture")
      .component-pin(v-for="(pin, index) in pins", v-bind:style="{ top:pin.top+'px', left: pin.left + 'px' }", v-on:click="removePin(pin)")
        span(v-if="pin.id", style="margin-top:15px") {{pin.id}}
</template>
<script type="text/babel">

  export default {
    name: 'VehicleDamage',
    components: {},
    data() {
      return {
        pins: [],
        rendered: false
      }
    },
    mounted() {
      this.render()
      setTimeout(() => {
        this.render()
        this.rendered = true
      }, 500)
    },
    methods: {
      render() {
        var container = $('.car-outline')
        this.items.forEach((item, key) => {
          this.pins.splice(key, 1, {
            id: item.id ? item.id : null,
            containerWidth: item.containerWidth,
            containerHeight: item.containerHeight,
            left: ((item.left) * container.width()) / item.containerWidth,
            top: ((item.top) * container.height()) / item.containerHeight
          })
        })
      },
      addPin(e) {
        if (!this.editable) {
          return
        }
        var pin = {
          containerWidth: this.container.width,
          containerHeight: this.container.height,
          left: e.offsetX - 25,
          top: e.offsetY - 25,
        }
        this.pins.push(pin)
        this.$emit('damagesUpdated', this.pins)
      },
      removePin(component) {
        if (!this.editable) {
          return
        }
        this.pins.forEach((item, key) => {
          if (component.left === item.left && component.top === item.top) {
            this.pins.splice(key, 1)
            this.$emit('damagesUpdated', this.pins)
          }
        })
      },
    },
    computed: {
      container() {
        var dmg = $('.car-outline')

        return {
          containerClass: dmg.attr('class'),
          width: dmg.width(),
          height: dmg.height(),
        }
      },
      pin() {
        return $('.component-pin')
      },
      vehicleOutline() {
        return this.vehicleType === 'Car' ? '/static/car_outline.png' : '/static/bike_outline.jpg'
      }
    },
    props: {
      items: {
        required: true,
        type: Array
      },
      editable: {
        default: false
      },
      vehicleType: {
        required: true
      },
      vehicleDamagePicture: {
        required: true
      }
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// VehicleDamage.vue?605e1f2a